module.exports = __webpack_public_path__ + "static/media/chat.199b14aa.svg";